import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
	transferButton: {
		backgroundColor: "transparent !important",
		boxShadow: "none",
		border: "none",
		textTransform: "capitalize",
		padding: "5px",
		textAlign: "start",
		display: "block",
		minWidth: "100%",
		"&:hover": {
			// backgroundColor:"transparent !important",
			boxShadow: "none",
			border: "none",
			padding: "5px",
			textAlign: "start",
			display: "block",
			minWidth: "100%",
		},
	},
	dialog: {
		width: "350px",
		margin: "0 auto",
	},
	dialogTital: {
		fontSize: "0.8rem",
		textAlign: "center",
		paddingTop: "20px",
		color: "#686D88",
	},
	avatar: {
		textAlign: "center",
		alignItems: "center",
		position: "absolute",
		// right:"78px",
		paddingBottom: "57px",
	},
	callerName: {
		display: "flex",
		fontSize: "2rem",
		textAlign: "center",
		color: "#526FEB",
		paddingTop: "71px",
		// paddingLeft:"56px"
	},
	callButton: {
		insetInlineStart: "73px",
		marginBottom: "30px",
		backgroundColor: "#526FEB",
		color: "white",
		textTransform: "capitalize",
		height: "35px",
		width: "132px",
	},
}));
